import { values, mapValues } from 'lodash';

/**
* Add global font "palette" to the global theme object.
* Remove useless version property from theme object.
*/
export default function themeMigrations(theme) {
  let updatedTheme = { ...theme };

  // Ensure the global theme doesnt already have a fontPalette object set up.
  if (!updatedTheme.global.hasOwnProperty('fontPalette')) {
    // Determine the primary and secondary fonts in the existing global theme by counting the usage numbers.
    const fontFamilyCounts = {};
    let primaryCount = 0;
    let secondaryCount = 0;
    let primaryFontFamily;
    let secondaryFontFamily;
    values(updatedTheme.global.elements).forEach(element => {
      const fontFamily = element.text.fontFamily;
      if (!fontFamilyCounts.hasOwnProperty(fontFamily)) {
        fontFamilyCounts[fontFamily] = 1;
      } else {
        fontFamilyCounts[fontFamily] += 1;
      }
      if (fontFamilyCounts[fontFamily] > primaryCount) {
        if (primaryFontFamily !== fontFamily) {
          secondaryCount = primaryCount;
          secondaryFontFamily = primaryFontFamily;
          primaryFontFamily = fontFamily;
        }
        primaryCount = fontFamilyCounts[fontFamily];
      } else if (fontFamilyCounts[fontFamily] > secondaryCount) {
        secondaryCount = fontFamilyCounts[fontFamily];
        secondaryFontFamily = fontFamily;
      }
    });

    const fontPalette = {
      primary: primaryFontFamily,
      secondary: secondaryFontFamily || primaryFontFamily
    };

    // Modify the font families in the global theme elements as necessary.
    const elements = mapValues(updatedTheme.global.elements, element => {
      let fontFamily = element.text.fontFamily;
      if (fontFamily === fontPalette.primary) {
        fontFamily = 'primary';
      } else if (fontFamily === fontPalette.secondary) {
        fontFamily = 'secondary';
      }
      return {
        ...element,
        text: {
          ...element.text,
          fontFamily
        }
      };
    });

    // Apply new fonts and elements info to the global theme.
    updatedTheme.global = {
      ...updatedTheme.global,
      fontPalette,
      elements
    };
  }

  // The version property is useless, so remove it.
  if (updatedTheme.hasOwnProperty('version')) {
    delete updatedTheme.version;
  }

  return updatedTheme;
}
